import type { EventRow } from "../types/event";
import { formatUtcForGCal, cryptoRandom } from "./utils";

function escapeICS(text: string) {
  return (text || "")
    .replace(/\\/g, "\\\\")
    .replace(/\n/g, "\\n")
    .replace(/,/g, "\\,")
    .replace(/;/g, "\\;");
}

export function toICS(ev: EventRow) {
  const uid = ev.id || cryptoRandom();
  const dtstamp = new Date().toISOString().replace(/[-:.]/g, "").slice(0, 15) + "Z";
  const dtstart = formatUtcForGCal(ev.start_iso);
  const dtend = formatUtcForGCal(ev.end_iso || ev.start_iso);
  const summary = escapeICS(ev.title);
  const description = escapeICS((ev.description || "") + (ev.join_url ? `\n\nAcesso: ${ev.join_url}` : ""));
  const location = escapeICS(ev.location_name || ev.address || "Online");

  return `BEGIN:VCALENDAR\nVERSION:2.0\nPRODID:-//CRO Brasil//Agenda Embaixadores//PT-BR\nCALSCALE:GREGORIAN\nMETHOD:PUBLISH\nBEGIN:VEVENT\nUID:${uid}\nDTSTAMP:${dtstamp}\nDTSTART:${dtstart}\nDTEND:${dtend}\nSUMMARY:${summary}\nDESCRIPTION:${description}\nLOCATION:${location}\nEND:VEVENT\nEND:VCALENDAR`;
}

export function toICSBatch(events: EventRow[]) {
  const dtstamp = new Date().toISOString().replace(/[-:.]/g, "").slice(0, 15) + "Z";
  const lines = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//CRO Brasil//Agenda Embaixadores//PT-BR",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH"
  ];
  for (const ev of events) {
    const uid = ev.id || cryptoRandom();
    const dtstart = formatUtcForGCal(ev.start_iso);
    const dtend = formatUtcForGCal(ev.end_iso || ev.start_iso);
    const summary = escapeICS(ev.title);
    const description = escapeICS((ev.description || "") + (ev.join_url ? `\n\nAcesso: ${ev.join_url}` : ""));
    const location = escapeICS(ev.location_name || ev.address || "Online");
    lines.push(
      "BEGIN:VEVENT",
      `UID:${uid}`,
      `DTSTAMP:${dtstamp}`,
      `DTSTART:${dtstart}`,
      `DTEND:${dtend}`,
      `SUMMARY:${summary}`,
      `DESCRIPTION:${description}`,
      `LOCATION:${location}`,
      "END:VEVENT"
    );
  }
  lines.push("END:VCALENDAR");
  return lines.join("\n");
}